module.exports = __webpack_public_path__ + "img/yt-wmemo.274c4eef.png";